module.exports = __webpack_public_path__ + "static/media/FPG_duurzaamheid_04.83d2ef05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sustainable/FPG_duurzaamheid_04.jpg
// module id = 772
// module chunks = 0